import { useEffect } from 'react';
import { useNotification } from '../contexts/NotificationContext';
import { processChangeEvent } from '../services/cache/cacheBus';
import { ChangeEventTypes } from '../services/notificationService';

/**
 * Mounted once near the app root. Subscribes to every known SSE
 * `ChangeEvent` type and forwards each event to `processChangeEvent`,
 * which translates it into cache invalidations on the cacheBus.
 *
 * Renders nothing.
 */
export const CacheBusBridge: React.FC = () => {
  const { subscribe } = useNotification();

  useEffect(() => {
    const unsubscribers = Object.values(ChangeEventTypes).map(eventType =>
      subscribe(eventType, (event) => {
        processChangeEvent(event);
      })
    );
    return () => { unsubscribers.forEach(u => u()); };
  }, [subscribe]);

  return null;
};

export default CacheBusBridge;
